import React from "react";
import styles from "./ActionMenuCheckbox.module.scss";
import { Checkbox } from "./../Forms"
import classNames from "classnames";

const ActionMenuCheckbox = ({ className, children, ariaLabel, ...props }) => {
    return <Checkbox {...props} className={classNames(styles.base, className)} ariaLabel={ariaLabel}>
        {children}
    </Checkbox>
};

export default ActionMenuCheckbox;